import React from "react";
import { Alert, Snackbar } from "@mui/material";
import { CheckCircle as CheckCircleIcon } from "@mui/icons-material";

const ToastNotification = (props) => {
  const { open, message, onClose = () => {}, type = "success" } = props;

  return (
    <>
      {open && message && (
        <Snackbar
          open={open}
          anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
          autoHideDuration={3000}
          onClose={onClose}
        >
          <Alert
            iconMapping={{
              success: <CheckCircleIcon />,
            }}
            variant="filled"
            onClose={onClose}
            severity={type}
            sx={{ width: "100%" }}
          >
            {message}
          </Alert>
        </Snackbar>
      )}
    </>
  );
};

export default ToastNotification;
